export const purchaseAr = {
  "Fournisseur": "المورد",
  "Prix.U": "سعر الوحدة",
  "Prix.V": "سعر البيع",
  "Facture": "فاتورة",

  "Donner le prix d'achat": "إعط سعر الشراء",
  "Donner le prix de vente": "إعط سعر البيع",
  "Donner la quantité": "أعط الكمية",
  "Prix D'achat": "سعر الشراء",
  "Prix de vente": "ثمن البيع",
  "Quantité": "الكمية",
  "Ajouter": "إضافة",
  "Modifier": "التعديل",
  "Supprimer": "مسح",
  "Fermer": "اغلاق",

  "Chercher un bon d'achat": "البحث عن فاتورة الشراء",

  
}